import { render } from "./MethodNotificationPage.vue?vue&type=template&id=22528aad"
import script from "./MethodNotificationPage.vue?vue&type=script&lang=js"
export * from "./MethodNotificationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__